<h2 mat-dialog-title>
  {{'inspectionReportEditTextCopyConfirmDialog.Confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'inspectionReportEditTextCopyConfirmDialog.MsgAllCopied' | translate}}</p>
  <p>{{'inspectionReportEditTextCopyConfirmDialog.MsgProceed' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button color="primary" mat-dialog-close>{{'inspectionReportEditTextCopyConfirmDialog.No' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="'yes'">{{'inspectionReportEditTextCopyConfirmDialog.Yes' | translate}}</button>
  </mat-dialog-actions>
</div>